module.exports = __webpack_public_path__ + "img/hero-6.204ea70c.png";